import { render } from "./rich-menu.vue?vue&type=template&id=45b27206&scoped=true"
import script from "./rich-menu.vue?vue&type=script&lang=js"
export * from "./rich-menu.vue?vue&type=script&lang=js"

import "./rich-menu.vue?vue&type=style&index=0&id=45b27206&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b27206"]])

export default __exports__